<template>
  <div class="corpotateTrainingHero">
    <modal name="corporate" :adaptive="true" max-width="500px" height="auto">
      <uform>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
              placeholder="Full Name"
              v-model="model.data.data.name"
              suggest=""
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
              placeholder="Company"
              v-model="model.data.data.company"
              suggest=""
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
              placeholder="Email"
              v-model="model.data.data.email"
              suggest=""
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
              placeholder="Phone"
              v-model="model.data.data.phone"
              suggest=""
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
              placeholder="Designation"
              v-model="model.data.data.designation"
              suggest=""
          ></uinput>
        </ulabel>
        <!--        <ulabel style="flex-basis: 100%; padding: 0em 1em;">-->
        <!--          <uinput placeholder="Number of Attendees" suggest="ie. 4"></uinput>-->
        <!--        </ulabel>-->
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
              placeholder="Area of Training"
              suggest=""
              type="textarea"
              v-model="model.data.data.details"
          ></uinput>
        </ulabel>
      </uform>
      <div style="display: flex; justify-content: space-around; margin: 20px 0;">
        <ubtn @click.native.prevent="submit">Submit</ubtn>
        <ubtn @click.native.prevent="$modal.hide('corporate')" color="white" textColor="red">Close</ubtn>
      </div>
    </modal>
    <u-modal
      v-model="contactUs"
      title="Request More Information"
      action="Request Quotation"
      @action="submit"
    >
      <uform>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Full Name"
            v-model="model.data.data.name"
            suggest=""
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Company"
            v-model="model.data.data.company"
            suggest=""
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Email"
            v-model="model.data.data.email"
            suggest=""
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Phone"
            v-model="model.data.data.phone"
            suggest=""
          ></uinput>
        </ulabel>
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Designation"
            v-model="model.data.data.designation"
            suggest=""
          ></uinput>
        </ulabel>
<!--        <ulabel style="flex-basis: 100%; padding: 0em 1em;">-->
<!--          <uinput placeholder="Number of Attendees" suggest="ie. 4"></uinput>-->
<!--        </ulabel>-->
        <ulabel style="flex-basis: 100%; padding: 0em 1em;">
          <uinput
            placeholder="Area of Training"
            suggest=""
            type="textarea"
            v-model="model.data.data.details"
          ></uinput>
        </ulabel>
      </uform>
    </u-modal>
    <uhero
      :image="heroData.image"
      :title="heroData.title"
      :body="heroData.body"
    >
      <template v-slot:btn>
        <u-btn-outlined @click.native.prevent="showModal"
          >Book a Session</u-btn-outlined
        >
      </template>
      <div class="container">
        <div class="workshop-hero-mobile">
          <div class="workshop_hero_content_mobile">
            <h3 class="workshop__text_mobile">
              {{ heroData.title }}
            </h3>
            <p class="workshop_desc_mobile">
              {{ heroData.body }}
            </p>
            <u-btn-outlined @click.native.prevent="contactUs = !contactUs">Book a Session</u-btn-outlined>
          </div>
        </div>
      </div>
    </uhero>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {
        data: {
          data: {}
        },
        type: "sponsorship",
        status: "request"
      },
      contactUs: false,
      heroData: {
        title: "Train your workforce for the future with Upskill’s Learning solutions",
        body: `Upskill your teams through our network of expert leaders from the smartest companies in Bangladesh and abroad`,
        image: require("../../assets/images/training.png")
      }
    };
  },
  methods: {
    showModal() {
      this.$modal.show("corporate")
    },
    submit() {
      this.model.created = new Date().toString()
      this.$upskill
        .vault(this.model)
        .then(() => {
          this.SuccessAlert("Request submitted!");
          this.$modal.hide('corporate')
        })
        .error(() => {
          this.ErrorAlert("Something went wrong.");
          this.$modal.hide('corporate')
        });
    }
  }
};
</script>
